<template>
  <v-dialog v-model="visible" :width="connections.length > 8 ? '760px' : '600px'" @click:outside="close">
    <div class="modal">
      <v-card flat>
        <v-card-title class="d-flex justify-space-between" style="padding: 16px 24px;">
          <span class="modal-title" style="font-size: 16px;">{{ title }}</span>
          <div>
            <v-btn icon small @click="exportCsv" title="Export CSV">
              <v-icon size="18">fa-download</v-icon>
            </v-btn>
            <v-btn icon @click="close">
              <v-icon>close</v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-divider></v-divider>
        <div v-if="connections.length === 0" class="pa-8 text-center" style="color: #717e91;">
          No connections found.
        </div>
        <div v-else :style="{ maxHeight: connections.length > 5 ? '70vh' : 'none', overflowY: connections.length > 5 ? 'auto' : 'visible' }">
          <div
            v-for="(conn, index) in connections"
            :key="index"
            style="padding: 10px 24px; border-bottom: 1px solid #e0e0e0;"
          >
            <div class="d-flex justify-space-between align-center">
              <div style="font-size: 14px; color: #333;">
                <span style="font-weight: 500;">{{ conn.vendorName }} &rarr; {{ conn.clientName }}</span>
                <span
                  :style="{
                    marginLeft: '8px',
                    padding: '1px 6px',
                    borderRadius: '4px',
                    fontSize: '11px',
                    fontWeight: '600',
                    backgroundColor: conn.ai_generated ? '#E3F2FD' : '#F3E5F5',
                    color: conn.ai_generated ? '#1565C0' : '#7B1FA2'
                  }"
                >{{ conn.ai_generated ? 'AI' : 'Direct' }}</span>
                <span style="color: #999; margin-left: 8px;">{{ formatDate(conn.created_at) }}</span>
              </div>
              <v-icon
                :style="{ color: conn.is_read ? '#12d120' : '#f44336', fontSize: '12px', marginLeft: '8px' }"
              >brightness_1</v-icon>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
export default {
  props: {
    title: { type: String, default: '' },
    referrals: { type: Array, default: () => [] },
    ownerId: { type: String, default: '' }
  },
  data() {
    return { visible: false };
  },
  computed: {
    connections() {
      const toMillis = (t) => {
        if (!t) return 0;
        if (typeof t === 'object' && typeof t.toDate === 'function') return t.toDate().getTime();
        if (typeof t === 'object' && typeof t.seconds === 'number') return t.seconds * 1000;
        const d = new Date(t);
        return isNaN(d.getTime()) ? 0 : d.getTime();
      };
      return this.referrals
        .filter(r => r.vendorId === this.ownerId || r.clientId === this.ownerId)
        .sort((a, b) => toMillis(b.created_at) - toMillis(a.created_at));
    }
  },
  methods: {
    open() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    formatDate(timestamp) {
      if (!timestamp) return '';
      let date;
      if (typeof timestamp === 'object' && typeof timestamp.toDate === 'function') {
        date = timestamp.toDate();
      } else if (typeof timestamp === 'object' && typeof timestamp.seconds === 'number') {
        date = new Date(timestamp.seconds * 1000);
      } else {
        date = new Date(timestamp);
      }
      if (isNaN(date.getTime())) return '';
      const dateStr = date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
      const timeStr = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
      return dateStr + ' - ' + timeStr;
    },
    exportCsv() {
      const rows = [['Vendor', 'Homeowner', 'Type', 'Date', 'Read']];
      for (const c of this.connections) {
        rows.push([c.vendorName, c.clientName, c.ai_generated ? 'AI' : 'Direct', this.formatDate(c.created_at), c.is_read ? 'Yes' : 'No']);
      }
      const csv = rows.map(r => r.map(v => '"' + String(v).replace(/"/g, '""') + '"').join(',')).join('\n');
      const blob = new Blob([csv], { type: 'text/csv' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = (this.title || 'connections') + '.csv';
      a.click();
      URL.revokeObjectURL(url);
    }
  }
};
</script>
